import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import Button from 'components/Button';
import SVG from 'components/SVG';
import { buildSavedFilterLabels } from 'features/reports/lib/buildSavedFilterLabels';
import saveSVG from 'features/reports/img/save.svg';
import trashSVG from 'features/reports/img/trash.svg';

import './SavedFilters.scss';

const b = block('saved-report-filters');

const SavedFilters = ({ isFormOpen, filterParams, onCloseForm, onSave, onApply, onDelete }) => {
  const locale = useSelector(state => state.locale.locale);
  const savedFilters = useSelector(state => state.reports.savedFilters);
  const [showAll, setShowAll] = useState(false);

  const preview = useMemo(
    () => (filterParams ? buildSavedFilterLabels(filterParams, locale) : null),
    [filterParams, locale],
  );

  const handleSubmit = event => {
    event.preventDefault();
    onSave(() => onCloseForm());
  };

  const visibleFilters = showAll ? savedFilters : savedFilters.slice(0, 4);

  return (
    <section className={b()}>
      <div className={b('header')}>
        <h2 className={b('title')}>
          <SVG className={b('title-icon')} svgProps={{ svg: saveSVG }} />
          <span>{locale.savedFilters}</span>
        </h2>
        {savedFilters.length > 4 && (
          <button type="button" className={b('show-all')} onClick={() => setShowAll(value => !value)}>
            {showAll ? locale.showLess : locale.showAll}
          </button>
        )}
      </div>

      {isFormOpen && preview && (
        <form className={b('form')} onSubmit={handleSubmit}>
          <div className={b('preview')}>
            <span className={b('preview-label')}>{locale.filterName}</span>
            <span className={b('preview-value')}>{preview.name}</span>
          </div>
          <div className={b('preview')}>
            <span className={b('preview-label')}>{locale.description}</span>
            <span className={b('preview-value')}>{preview.description || locale.noDescription}</span>
          </div>
          <div className={b('form-actions')}>
            <Button color="bordered" callBack={onCloseForm} text={locale.cancel} />
            <Button type="submit" text={locale.save} />
          </div>
        </form>
      )}

      {visibleFilters.length ? (
        <div className={b('grid')}>
          {visibleFilters.map(item => (
            <div className={b('item')} key={item.id}>
              <button type="button" className={b('item-main')} onClick={() => onApply(item)}>
                <span className={b('item-name')}>{item.name}</span>
                <span className={b('item-description')}>{item.description || locale.noDescription}</span>
                <span className={b('item-date')}>{item.createdAt}</span>
              </button>
              <button
                type="button"
                aria-label={locale.deleteFilter}
                className={b('delete')}
                onClick={() => onDelete(item.id)}>
                <SVG className={b('delete-icon')} svgProps={{ svg: trashSVG }} />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className={b('empty')}>{locale.noSavedFilters}</div>
      )}
    </section>
  );
};

export default SavedFilters;
